export default "__VITE_ASSET__26539d5d__"